import { IAppState } from "../app.state";

export const selectObjects = (state: IAppState) => state.objects.list;

export const selectSelectedObject = (state: IAppState) => state.objects.selected;